import { useState } from "react";
import "./RateOverview.scss";

const networkProviders = [
  "1&1",
  "Ay Yildiz",
  "Congstar",
  "Kabel Deutschland",
  "MoWoTel",
  "Netzbetreiber 1",
  "Netzbetreiber 2",
  "Netzbetreiber 3",
  "o2",
  "O2 GK",
  "O2 QP",
  "Otelo",
  "T-Mobile",
  "Telekom",
  "Telekom Festnetz",
  "Telekom GK",
  "Unity Media",
  "Vodafone",
  "Vodafone DSL",
];

const statusOptions = ["Alle", "aktiv", "nicht aktiv"];

const categoryOptions = [
  "Alle",
  "Credit",
  "Option",
  "Prepaid",
  "Daten",
  "LTE",
  "Festnetz",
  "DSL",
  "WKZ",
];

interface Rate {
  netz: string;
  nr: string;
  tarifname: string;
  kat: string;
  gruppeVvl: string;
  mitProv: string;
  punkte: string;
  auGuBp: string;
  status: string;
}

const sampleRates: Rate[] = [
  { netz: "Telekom", nr: "1001", tarifname: "MagentaMobil S", kat: "Credit", gruppeVvl: "A", mitProv: "10,00 €", punkte: "50", auGuBp: "5,00 €", status: "aktiv" },
  { netz: "Vodafone", nr: "1002", tarifname: "Red S", kat: "Credit", gruppeVvl: "A", mitProv: "12,00 €", punkte: "60", auGuBp: "6,00 €", status: "aktiv" },
  { netz: "o2", nr: "1003", tarifname: "o2 Free S", kat: "Prepaid", gruppeVvl: "B", mitProv: "8,00 €", punkte: "40", auGuBp: "4,00 €", status: "aktiv" },
  { netz: "1&1", nr: "1004", tarifname: "All-Net-Flat", kat: "Credit", gruppeVvl: "A", mitProv: "11,00 €", punkte: "55", auGuBp: "5,50 €", status: "nicht aktiv" },
  { netz: "Congstar", nr: "1005", tarifname: "Allnet Flat", kat: "Prepaid", gruppeVvl: "B", mitProv: "7,00 €", punkte: "35", auGuBp: "3,50 €", status: "aktiv" },
];

export default function RateOverview() {
  const [network, setNetwork] = useState("");
  const [status, setStatus] = useState("Alle");
  const [category, setCategory] = useState("Alle");
  const [searchTerm, setSearchTerm] = useState("");

  function handleShow() {
    // Filter-Logik würde hier implementiert werden
  }

  function handleReset() {
    setNetwork("");
    setStatus("Alle");
    setCategory("Alle");
    setSearchTerm("");
  }

  return (
    <section className="sales-layout__page rate-overview" aria-labelledby="rate-overview-title">
      <header className="rate-overview__header">
        <h1 id="rate-overview-title">Mitarbeiter Tariffliste</h1>
      </header>

      <div className="rate-overview__filter-bar">
        <div className="rate-overview__filter-group">
          <select
            className="rate-overview__select"
            value={network}
            onChange={(event) => setNetwork(event.target.value)}
            aria-label="Netzbetreiber"
          >
            <option value="">Netzbetreiber auswählen</option>
            {networkProviders.map((provider) => (
              <option key={provider} value={provider}>
                {provider}
              </option>
            ))}
          </select>

          <select
            className="rate-overview__select"
            value={status}
            onChange={(event) => setStatus(event.target.value)}
            aria-label="Status"
          >
            {statusOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            className="rate-overview__select"
            value={category}
            onChange={(event) => setCategory(event.target.value)}
            aria-label="Kategorie"
          >
            {categoryOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <label className="rate-overview__search">
            <span className="rate-overview__search-label">suche</span>
            <input
              type="search"
              className="rate-overview__search-input"
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
              placeholder=""
            />
          </label>

          <button
            type="button"
            className="rate-overview__btn rate-overview__btn--show"
            onClick={handleShow}
          >
            anzeigen
          </button>
        </div>
      </div>

      <div className="rate-overview__table-wrapper">
        <table className="rate-overview__table">
          <thead>
            <tr>
              <th scope="col">Netz</th>
              <th scope="col">Nr</th>
              <th scope="col">Tarifname</th>
              <th scope="col">kat</th>
              <th scope="col">Gruppe vvl</th>
              <th scope="col">Mit-Prov</th>
              <th scope="col">Punkte</th>
              <th scope="col">AU/GU BP</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {sampleRates.length === 0 ? (
              <tr>
                <td colSpan={9} className="rate-overview__empty-state">
                  Keine Tarife gefunden.
                </td>
              </tr>
            ) : (
              sampleRates.map((rate, index) => (
                <tr key={index}>
                  <td>{rate.netz}</td>
                  <td>{rate.nr}</td>
                  <td>{rate.tarifname}</td>
                  <td>{rate.kat}</td>
                  <td>{rate.gruppeVvl}</td>
                  <td>{rate.mitProv}</td>
                  <td>{rate.punkte}</td>
                  <td>{rate.auGuBp}</td>
                  <td>
                    <span className={`rate-overview__status rate-overview__status--${rate.status === "aktiv" ? "active" : "inactive"}`}>
                      {rate.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="rate-overview__actions">
        <button
          type="button"
          className="rate-overview__btn rate-overview__btn--reset"
          onClick={handleReset}
        >
          Zurücksetzen
        </button>
      </div>
    </section>
  );
}
